// SINGLE HOMEITEM COMPONENT, USED IN Home.js

import React, { useContext } from "react";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { pl } from "./../data/pl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Painting = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: column;
  width: ${(props) => (props.width === "2" ? "43vw" : "21vw")};
  height: auto;
  padding: 0;
  text-decoration: none;
  color: ${variables.DARK};
  margin-bottom: 2rem;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 500px) {
    width: 85vw;
    margin-bottom: 2rem;
  }
`;

const Image = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
  transition: 0.3s;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 99%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    color: ${variables.BLACK};
    font-size: ${variables.SMALL_TITLE_FONT};
    font-weight: bold;
    text-align: center;
    pointer-events: none;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(8px) brightness(80%);
    transition: opacity 0.3s ease, backdrop-filter 0.3s ease,
      background-color 0.3s ease;
  }

  &:hover::after {
    content: attr(data-availability);
    opacity: 1;
  }
`;

const Title = styled.p`
  text-decoration: none;
  font-weight: bold;
`;

const Cycle = styled.p`
  font-family: "Open Sans Condensed", sans-serif;
`;

const Availability = styled.p`
  position: absolute;
  bottom: 50%;
  ${variables.Flex};
  width: 100%;
  height: auto;
  color: ${variables.WHITE};
  font-size: ${variables.SMALL_TITLE_FONT};
  pointer-events: none;
`;

export const HomeItem = ({ artworkId }) => {
  const usedLanguage = useContext(LanguageContext);

  let { artworkTitle, artworkCycle, artworkWidth } =
    pl.artworks[artworkId] || {};
  let { poetryBookTitle, poetryBookCycle } = pl.poetry[artworkId] || {};

  const { artworkAvailability } = usedLanguage.language.artworks[artworkId];

  return (
    <>
      {window.location.href.split("/").pop().startsWith("PO") ? (
        <Painting>
          <Image>
            <LazyLoadImage
              effect="blur"
              src={`./images/poetry/${artworkId}/${artworkId}-1.jpg`}
              alt={`${poetryBookTitle}, ${poetryBookCycle}, Michał Król - Structuralist`}
              position={"relative"}
              width={"100%"}
              height={"100%"}
            />
          </Image>
          <Title>{poetryBookTitle}</Title>
          <Cycle>{poetryBookCycle}</Cycle>
        </Painting>
      ) : (
        <Painting width={artworkWidth}>
          <Image data-availability={artworkAvailability}>
            <LazyLoadImage
              effect="blur"
              src={`./images/artworks/${artworkId}/${artworkId}-1.jpg`}
              alt={`${artworkTitle}, ${artworkCycle}, Michał Król - Structuralist`}
              position={"relative"}
              width={"100%"}
              height={"100%"}
            />
          </Image>
          <Title>{artworkTitle}</Title>
          <Cycle>{artworkCycle}</Cycle>
        </Painting>
      )}
    </>
  );
};
